angular.module('GlobalHelpersModule').filter "shortTime", ->
  (time) ->
    if time? then moment.utc(time).format('h:mma') else ""